import React from 'react';
import { CardViewContentProps } from './types';
import ApartmentOutlinedIcon from '../../../../../assets/svg/apartment.svg?react';
import BadgeOutlinedIcon from '../../../../../assets/svg/badge-light.svg?react';
import SupportAgentOutlinedIcon from '../../../../../assets/svg/support-agent.svg?react';
import BusinessCenterIcon from '../../../../../assets/svg/business-center-v2.svg?react';
import { useTranslation } from 'react-i18next';
import DocumentListVault from '../document-list-vault/DocumentListVault';
import { useDocumentsMetaData } from '../../hooks/useDocumentsMetaData';
import CategoryCard from '../../../../common/category-card/CategoryCard';
import CategoryCardGrid from '../../../../common/category-card/CategoryCardGrid';
import { CATEGORY_CARD_ACCENTS, CategoryCardTab } from '../../../../common/category-card/types';
import PreviewBusiness from '../card-previews/preview-business/Preview';
import PreviewEmployment from '../card-previews/preview-employment/Preview';
import PreviewCustomers from '../card-previews/preview-customers/Preview';
import PreviewSuppliers from '../card-previews/preview-suppliers/Preview';

type VaultCategoryConfig = {
  tab: CategoryCardTab;
  category: string;
  icon: React.ReactNode;
  preview: React.ReactNode;
};

const vaultCategories: VaultCategoryConfig[] = [
  {
    tab: 'Business',
    category: 'business',
    icon: <ApartmentOutlinedIcon id='documentVaultCardViewContentBusinessCardApartmentIcon' />,
    preview: <PreviewBusiness />,
  },
  {
    tab: 'Employment',
    category: 'employment',
    icon: <BadgeOutlinedIcon id='documentVaultCardViewContentEmploymentCardBadgeIcon' />,
    preview: <PreviewEmployment />,
  },
  {
    tab: 'Customers',
    category: 'customers',
    icon: (
      <SupportAgentOutlinedIcon id='documentVaultCardViewContentCustomersCardSupportAgentIcon' />
    ),
    preview: <PreviewCustomers />,
  },
  {
    tab: 'Suppliers',
    category: 'suppliers',
    icon: <BusinessCenterIcon id='documentVaultCardViewContentSuppliersCardBusinessCenterIcon' />,
    preview: <PreviewSuppliers />,
  },
];

export const CardViewContent = ({
  activeTab,
  changeTabFunction,
  documents,
}: CardViewContentProps) => {
  const { t } = useTranslation();
  const { uploadedDocumentsMetaData } = useDocumentsMetaData(activeTab);
  const filterDataByCategory = (category: string) =>
    uploadedDocumentsMetaData.find((el) => el.category === category);

  const getCountLabel = (count: number) =>
    t(count === 1 ? 'categoryCards.documentCountSingular' : 'categoryCards.documentCountPlural', {
      count,
    });

  if (activeTab === 'All') {
    return (
      <CategoryCardGrid id='documentVaultCardViewContentGrid'>
        {vaultCategories.map(({ tab, category, icon, preview }) => {
          const categoryData = filterDataByCategory(category);
          return (
            <CategoryCard
              key={category}
              id={`documentVaultCardViewContent${tab}Card`}
              title={t(tab)}
              countLabel={getCountLabel(categoryData?.count ?? 0)}
              description={t(`documentVault.descriptions.${category}`)}
              accent={CATEGORY_CARD_ACCENTS[tab]}
              icon={icon}
              onClick={() => changeTabFunction?.(tab)}
              hasNewLabel={categoryData?.isNew}
              previewBlock={preview}
            />
          );
        })}
      </CategoryCardGrid>
    );
  } else {
    /*if (!workflow) {
            if (activeTab === 'Business') {
              return <BusinessCategoryContent templates={templates} setWorkflow={setWorkflow} />;
            } else if (activeTab === 'Employment') {
              return <EmploymentCategoryContent templates={templates} setWorkflow={setWorkflow} />;
            } else if (activeTab === 'Customers') {
              return <CustomersCategoryContent templates={templates} setWorkflow={setWorkflow} />;
            } else if (activeTab === 'Suppliers') {
              return <SuppliersCategoryContent templates={templates} setWorkflow={setWorkflow} />;
            }
          }*/
    return (
      <>
        {/*<Box className={styles.breadcrumbs}>
          <Typography
            variant='h3'
            component='h3'
            className={styles.documentViewText}
            onClick={() => setWorkflow(null)}
          >
            {t('headers.workflows')}
          </Typography>
          <Typography variant='body2' className={styles.separator}>
            ›
          </Typography>
          <Typography variant='body2' className={styles.documentViewText}>
            {workflow}
          </Typography>
        </Box>*/}
        <DocumentListVault documents={documents} compact />
      </>
    );
  }
};
